import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { FlashMessage, MessageLevel } from '../flash.message.record';

@Injectable()
export class FlashMessagesService {
    private messageStream: Subject<FlashMessage>;

    constructor() {
        this.messageStream = new Subject();
    }

    get messages(): Observable<FlashMessage> {
        return this.messageStream.asObservable();
    }

    public post(flashMessage: FlashMessage) {
        this.messageStream.next(flashMessage);
    }

    public error(flashMessage: string) {
        console.log('ERROR: ' + flashMessage);
        this.flashMessage(MessageLevel.ERROR, flashMessage, false, false);
    }

    public warn(flashMessage: string) {
        this.flashMessage(MessageLevel.WARN, flashMessage, false, false);
    }

    public info(flashMessage: string) {
        this.flashMessage(MessageLevel.INFO, flashMessage, false, false);
    }

    public success(flashMessage: string) {
        this.flashMessage(MessageLevel.SUCCESS, flashMessage, true, true);
    }

    private flashMessage(level, message, displayThroughNavigation: boolean, autoClose: boolean) {
        this.post(new FlashMessage(level, message, displayThroughNavigation, autoClose));
    }
}
